import "./modules/Animate";
import "./modules/ToggleBodyClass";
import "./modules/Dropdown";
import "./modules/ScrollClass";
import "./modules/CardCarousel";
import "./modules/FooterCarousel";
import "./modules/Modal";
import "./modules/Accordion";
import "./modules/Video";
import "./modules/ContactForm";

jQuery(function ($) {

  const $SVG = $('#loginSVG');

  if ($SVG.length) {
    $SVG.css("opacity", "1");

    const duration = 500;
    const stagger = 5;
    const showBgBeforeEnd = 500;

    const pathCount = $SVG.find('path, line, polyline, polygon').length;
    const totalDuration = duration + (stagger * pathCount);

    var SVG = $SVG.drawsvg({
      callback: function () {

      },
      duration: duration,
      stagger: stagger
    });

    SVG.drawsvg('animate');

    setTimeout(function () {
      $('.login__bg').addClass('is-visible');
      $SVG.fadeOut(1000);
    }, Math.max(0, totalDuration - showBgBeforeEnd));
  }
  
});
